import React, { ReactNode } from "react";

import { bem } from "@react-md/utils";
import Tooltip from "antd/es/tooltip";

import { isDefined, linearScale } from "@mapmycustomers/shared";

const block = bem("mmc-scale-indicator");

const defaultTooltipGetter = (value: number) => `${value}`;

export interface ScaleIndicatorProps {
  inverted?: boolean;
  max?: number;
  maxText?: ReactNode;
  min?: number;
  minText?: ReactNode;
  tooltipGetter?: (value: number) => ReactNode;
  value?: number;
}

export const ScaleIndicator = ({
  inverted,
  max = 1,
  maxText,
  min = 0,
  minText,
  tooltipGetter = defaultTooltipGetter,
  value,
}: ScaleIndicatorProps) => {
  return (
    <div className={block()}>
      <div className={block("bar")} />
      {isDefined(value) && (
        <Tooltip title={tooltipGetter(value)}>
          <svg
            className={block("arrow")}
            fill="none"
            height="15"
            style={{
              left: `${linearScale(min, max, inverted ? 99 : 1, inverted ? 1 : 99, value)}%`,
            }}
            viewBox="0 0 20 15"
            width="20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.7504 14.551C10.3531 15.1291 9.49953 15.1291 9.10219 14.551L0.177622 1.56643C-0.278423 0.902919 0.196608 7.13623e-07 1.00173 7.56858e-07L18.8509 1.71535e-06C19.656 1.75858e-06 20.131 0.90292 19.675 1.56643L10.7504 14.551Z"
              fill="currentColor"
            />
          </svg>
        </Tooltip>
      )}
      {(minText || maxText) && (
        <div className={block("labels")}>
          <div className={block("labels-left")}>{inverted ? maxText : minText}</div>
          <div className={block("labels-right")}>{inverted ? minText : maxText}</div>
        </div>
      )}
    </div>
  );
};
